import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Link from 'components/link';
import { Form, Field, Button } from 'components/form';
import { FadeInUp } from 'components/transitions';
import SwellLogo from 'components/logo/logo';
import Icon from 'components/icon/icon';
import OAuthButtons from 'components/login/oauth-buttons';
import LoginPageLeftPart from 'components/login/left-part';
import auth from 'services/auth';
import Cookies from 'universal-cookie';
import './login.scss';

const cookies = new Cookies();
const { GOOGLE_CLIENT_ID, GITHUB_CLIENT_ID } = process.env;
const hasOAuthProviders = Boolean(GOOGLE_CLIENT_ID || GITHUB_CLIENT_ID);

export default class LoginPage extends React.PureComponent {
  static propTypes = {
    onClickRecover: PropTypes.func,
    onSubmitLogin: PropTypes.func,
    isPartnerLogin: PropTypes.bool,
    isSuperAdminLogin: PropTypes.bool,
    showOAuth: PropTypes.bool,
    partnerId: PropTypes.string,
  };

  onClickLogin = (event) => {
    // Hack to workaround a weird issue where
    // submit does not work the 2nd time this form loads
    event.preventDefault();
    this.refs.form.submit();
  };

  onKeyDown = (event) => {
    switch (event.keyCode) {
      case 13: // enter
        event.preventDefault();
        this.refs.form.submit();
        break;
      default:
    }
  };

  onClickRecover = () => {
    const { onClickRecover } = this.props;
    const { form: { values = {} } = {} } = this.refs;
    onClickRecover(values);
  };

  render() {
    const {
      onSubmitLogin,
      isPartnerLogin = false,
      isSuperAdminLogin = false,
      showOAuth = true,
      partnerId,
    } = this.props;
    const cli = !!cookies.get('cliUrl');

    return (
      <Fragment>
        <div className="auth-split">
          <LoginPageLeftPart isPartnerLogin={isPartnerLogin} />
          <div className="auth-split_panel">
            {!isSuperAdminLogin && !cli && !partnerId && (
              <a
                className="auth-toplink"
                href={
                  isPartnerLogin
                    ? auth.getPartnerSignupUrl()
                    : auth.getSignupUrl()
                }
              >
                Sign up instead
              </a>
            )}
            <div className="auth-split_form auth-form-fields">
              <div className="logo-container">
                <SwellLogo />
              </div>

              <FadeInUp>
                <div>
                  <Form onSubmit={onSubmitLogin} autoFocus={true} ref="form">
                    <fieldset>
                      <Field
                        label="Email"
                        type="text"
                        name="username"
                        required={true}
                        showError={false}
                        onKeyDown={this.onKeyDown}
                        large={true}
                        className="login-form-field-margin-16"
                      />
                      <Field
                        label="Password"
                        type="password"
                        name="password"
                        rules="required"
                        showError={false}
                        onKeyDown={this.onKeyDown}
                        large={true}
                      />
                    </fieldset>
                    <div className="login-actions">
                      <Button
                        type="submit"
                        styleType="default"
                        onClick={this.onClickLogin}
                        size="large"
                      >
                        Log in
                      </Button>
                    </div>
                  </Form>
                  {showOAuth && hasOAuthProviders && (
                    <Fragment>
                      <div className="oauth-buttons_divider">
                        <span>or</span>
                      </div>
                      <OAuthButtons flow="login" partnerId={partnerId} />
                    </Fragment>
                  )}
                  <div className="login-note">
                    <span className="forgot-password">
                      Forgot your password?{' '}
                    </span>
                    {isPartnerLogin ? (
                      // Plain anchor: on /:partnerId/login both Link and the
                      // router would prefix the partner id, and /recover is
                      // only routed unscoped
                      <a href="/recover" className="recover-password">
                        Recover
                      </a>
                    ) : (
                      <Link
                        to="/recover"
                        onClick={this.onClickRecover}
                        className="recover-password"
                      >
                        Recover
                      </Link>
                    )}
                  </div>
                </div>
              </FadeInUp>
            </div>
          </div>
        </div>
        {cli && (
          <div className="cli">
            <Icon
              svgType="terminal-square"
              className="cli-icon"
              width={24}
              height={24}
            />
            <div>Command-line interface</div>
          </div>
        )}
      </Fragment>
    );
  }
}
